var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader primary--text",style:({ height: _vm.height, paddingTop: _vm.paddingTop })},[_c('i',{staticClass:"fas fa-spin",class:_vm.iconName}),(_vm.showProgress)?_c('v-progress-linear',{staticClass:"my-6",attrs:{"value":_vm.progress,"color":"primary"}}):_vm._e(),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }